import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import { IUserData } from '../../../types/users/IUser';

export interface IUsersState {
  users: IUserData[];
  usersFetchStatus: IFetchStatus;
  usersError: string | null;
}

export const usersInitialState: IUsersState = {
  users: [],
  usersFetchStatus: createDefaultFetch(),
  usersError: null,
};
